import {useBaseMutation, useBaseQuery, useInvalidateQueries} from './useBaseQuery.ts';
import {ttsVoiceApi} from '../api/ttsVoiceApi.ts';
import {
    AdminVoiceItem,
    RegenerateSampleResult,
    UpdateVoiceRequest,
    VoiceSyncResult,
} from '../types/ttsVoice.ts';
import NoDataResponse from '../models/noDataResponse.ts';

export const ttsVoiceKeys = {
    all: ['ttsVoice'] as const,
    list: (lang: string) => [...ttsVoiceKeys.all, 'list', lang] as const,
};

export const useTtsVoiceList = (lang: string) => {
    return useBaseQuery<AdminVoiceItem[]>(
        ttsVoiceKeys.list(lang),
        () => ttsVoiceApi.list(lang),
        {staleTime: 10_000, enabled: !!lang},
    );
};

export const useSyncTtsVoices = () => {
    const {invalidateByPrefix} = useInvalidateQueries();
    return useBaseMutation<{ langCode: string }, VoiceSyncResult>(
        ({langCode}) => ttsVoiceApi.sync(langCode),
        {
            onSuccess: () => {
                invalidateByPrefix(ttsVoiceKeys.all);
            },
        },
    );
};

export const useUpdateTtsVoice = () => {
    const {invalidateByPrefix} = useInvalidateQueries();
    return useBaseMutation<{ id: number; body: UpdateVoiceRequest }, AdminVoiceItem>(
        ({id, body}) => ttsVoiceApi.update(id, body),
        {
            onSuccess: () => {
                invalidateByPrefix(ttsVoiceKeys.all);
            },
        },
    );
};

export const useRegenerateTtsVoiceSample = () => {
    const {invalidateByPrefix} = useInvalidateQueries();
    return useBaseMutation<{ id: number }, RegenerateSampleResult>(
        ({id}) => ttsVoiceApi.regenerateSample(id),
        {
            onSuccess: () => {
                invalidateByPrefix(ttsVoiceKeys.all);
            },
        },
    );
};

export const useUpdateTtsSampleText = () => {
    return useBaseMutation<{ code: string; sampleText: string }, NoDataResponse>(
        ({code, sampleText}) => ttsVoiceApi.updateSampleText(code, sampleText),
    );
};
